import React, { useEffect, useState } from "react"
import { NavLink, useLocation } from "react-router-dom"
import { IEvent } from "../../models/Event";
import { StatusBtn } from "../StatusBtn";

const navLinks = [
    { path: 'home', label: 'בית' },
    { path: 'enrollment', label: 'הרשמה' },
    { path: 'details', label: 'פרטים מלאים' },
    { path: 'maps', label: 'מפות ומסלולים' },
    { path: 'gallery', label: 'גלריה' },
    { path: 'contact', label: 'צור קשר' },
]

export const AppHeader: React.FC<{ event: IEvent, existPage: string }> = ({ event, existPage }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false)
    const { pathname } = useLocation()
    const basePath = `/${event.codeName}`
    const isHomeRoot = pathname === basePath || pathname === `${basePath}/`

    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > 8)
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    useEffect(() => {
        setIsMenuOpen(false)
    }, [pathname])

    useEffect(() => {
        if (!isMenuOpen) return

        const onKeyDown = (ev: KeyboardEvent) => {
            if (ev.key === 'Escape') setIsMenuOpen(false)
        }
        document.body.classList.add('menu-open')
        window.addEventListener('keydown', onKeyDown)
        return () => {
            document.body.classList.remove('menu-open')
            window.removeEventListener('keydown', onKeyDown)
        }
    }, [isMenuOpen])

    const headerClassName = ['site-header', isScrolled && 'is-scrolled', isMenuOpen && 'is-menu-open'].filter(Boolean).join(' ')

    return (
        <header id="main-header" className={headerClassName}>
            <div className="container site-header__inner">
                <NavLink className="site-brand" to={`${basePath}/`}>
                    <img className="site-brand__logo" src={event.logo} alt={'event logo'} />
                    {event.shortName && <span className="site-brand__name">{event.shortName}</span>}
                </NavLink>
                <span className="site-header__page">{existPage}</span>

                <nav id="navbar" className="site-nav">
                    <ul>
                        {navLinks.filter(link => link.path !== 'maps' || event.showMaps).map(link =>
                            <li key={link.path}>
                                <NavLink
                                    className={({ isActive }) => (isActive || (link.path === 'home' && isHomeRoot) ? "active-class" : "not-active-class")}
                                    onClick={() => setIsMenuOpen(false)}
                                    to={`${basePath}/${link.path}`}>
                                    {link.label}
                                </NavLink>
                            </li>
                        )}
                    </ul>
                </nav>

                <div className="site-header__cta">
                    <StatusBtn event={event} />
                </div>

                <button
                    type="button"
                    className="menu-toggle"
                    aria-label="תפריט"
                    aria-controls="navbar"
                    aria-expanded={isMenuOpen}
                    onClick={() => setIsMenuOpen(isOpen => !isOpen)}>
                    <span className="material-icons">{isMenuOpen ? 'close' : 'menu'}</span>
                </button>
            </div>
        </header>
    )
}
